export default __webpack_public_path__ + "static/museo-sans-regular-1c2cd58a6a235357eb7aff71d9760c7d.eot";